// MaterialChanges.tsx — (B112; planning 10-24 19:20, 20:20; Creative 2's C2.5-4) above Approve at the final review: what was
// made differently from the plan, each item's heading and sentence (the store's words, as they are) with its clip, which
// moves the player to that moment where the engine says when the clip starts. Nothing changed: one line saying so. The
// list unreadable: the gate shows without it, and says why. Read, never decided: approving stays the gate's own decision.
import type { RefObject } from "react";
import { useQuery } from "@tanstack/react-query";
import { videosApi, type EngineBeat } from "@/api/videos.ts";
import { clipStarts, materialShown } from "@/lib/material.ts";
import { w } from "@/lib/words.ts";

export function MaterialChanges({ videoId, beats, player }: { videoId: string; beats: readonly EngineBeat[]; player: RefObject<HTMLVideoElement | null> }) {
  const q = useQuery({ queryKey: ["material", videoId], queryFn: () => videosApi.material(videoId), retry: 1 });
  const shown = materialShown(q.data ?? null, q.isError, clipStarts(beats));
  if (!shown) return null;
  const seek = (s: number) => { const v = player.current; if (!v) return; v.currentTime = s; v.scrollIntoView({ block: "nearest" }); void v.play().catch(() => { /* catch-reason: the browser may refuse to play unasked; the player is at the moment */ }); };
  return (
    <section aria-label={w("page.material.title")} style={{ border: "1px solid var(--tf-rule)", borderRadius: 8, padding: 12, margin: "16px 0 0" }}>
      <h3 style={{ margin: "0 0 8px" }}>{w("page.material.title")}</h3>
      {shown.kind !== "items" ? <p className="tf-muted" style={{ margin: 0 }}>{shown.line}</p> : (
        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 10 }}>
          {shown.items.map((i) => (
            <li key={i.key}>
              <div><strong>{i.heading}</strong>{" · "}
                {i.startSec === null ? <span className="tf-muted">{i.clipLabel}</span>
                  : <a href="#" onClick={(e) => { e.preventDefault(); seek(i.startSec!); }}>{i.clipLabel}</a>}</div>
              <div className="tf-muted" style={{ fontSize: 14 }}>{i.sentence}</div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
